import React, {Component} from 'react'
import {bezierEdge} from "../../store/model";
import {SetSelectedEdgesAction, SetSelectedPapersAction} from "../../store/actions";
import {getInitialSelectedPapers, getRelatedPapersAndEdgesByNodes} from "../../utils";


interface props {
    state: any
    scale: number
    setSelectedEdges: (newState: Array<number>) => SetSelectedEdgesAction;
    setSelectedPapers: (newState: Array<number>) => SetSelectedPapersAction;
}

const darkOpacity = 0.1;
const normalColor = 'grey';
const highlightColor = '#666666';
const highLightOpacity = 1;


class Edges extends Component<props> {

    async componentDidMount() {
    }


    render() {
        const Edges: bezierEdge[] = this.props.state.EdgesData.Edges;
        const selectedEdges: number[] = this.props.state.EdgesData.SelectedEdges;
        const bgSelectedEdges: number[] = this.props.state.EdgesData.HalfSelectedEdges;
        const handleMouseOver = (id: number) => {
            if (this.props.state.NodesData.SelectedNodes.length === 0) {
                const p2 = id % 100;
                const p1 = (id - p2) / 100;
                const {edges, papers} = getRelatedPapersAndEdgesByNodes([p1, p2]);
                this.props.setSelectedEdges(edges);
                this.props.setSelectedPapers(papers);
            }
        };
        const handleMouseOut = (id: number) => {
            if (this.props.state.NodesData.SelectedNodes.length === 0) {
                this.props.setSelectedEdges([]);
                this.props.setSelectedPapers(getInitialSelectedPapers());
            }
        };
        return (
            <>
                {Edges.map((d: bezierEdge, index: number) => (
                    <path
                        id={"edge" + index}
                        key={index}
                        d={d.pathParse}
                        stroke={selectedEdges.includes(d.ID) ? highlightColor : normalColor}
                        strokeWidth={1.5 * this.props.scale}
                        fill="none"
                        pointerEvents={bgSelectedEdges.includes(d.ID) ? "al" : "none"}
                        opacity={selectedEdges.includes(d.ID) ? highLightOpacity : (bgSelectedEdges.includes(d.ID) ? darkOpacity : 0)}
                        onMouseOver={function (e) {
                            handleMouseOver(d.ID)
                        }}
                        onMouseOut={function (e) {
                            handleMouseOut(d.ID)
                        }}
                    />
                ))}
            </>
        )
    }
}

export default Edges;